if (!customElements.get('sheworks-style-browser')) {
  customElements.define('sheworks-style-browser', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.rail = this.querySelector('[data-style-rail]');
      this.controls = this.querySelector('.sw-style__controls');
      this.previous = this.querySelector('[data-style-previous]');
      this.next = this.querySelector('[data-style-next]');
      if (!this.rail) return;
      this.update = () => {
        const overflow = this.rail.scrollWidth > this.rail.clientWidth + 2;
        const cards = [...this.rail.children];
        const bounds = this.rail.getBoundingClientRect();
        const first = cards[0]?.getBoundingClientRect();
        const last = cards.at(-1)?.getBoundingClientRect();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        this.controls.hidden = !overflow;
        this.previous.disabled = !overflow || (rtl ? first.right <= bounds.right + 3 : first.left >= bounds.left - 3);
        this.next.disabled = !overflow || (rtl ? last.left >= bounds.left - 3 : last.right <= bounds.right + 3);
      };
      const move = (direction) => {
        const step = this.rail.firstElementChild?.getBoundingClientRect().width || this.rail.clientWidth;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        this.rail.scrollBy({ left: (step + gap) * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
      document.addEventListener('shopify:block:select', (event) => {
        const block = [...this.rail.children].find((item) => item.dataset.blockId === event.detail?.blockId);
        block?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }, options);
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.rail);
      this.update();
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
